export default __webpack_public_path__ + "static/media/uploader-relion-2.083e4c3b.png";